@if (showDepartmentFilter()) {
  <div class="flex shrink-0 items-center border-0 border-b border-solid border-default bg-surface-page p-sm">
    <departments-dropdown variant="transparent" />
  </div>
}
@if (loading() || isError()) {
  <div class="flex size-full flex-col">
    <div class="m-auto">
      @if (loading()) {
        <sb-loading-state />
      } @else {
        <sb-empty-state [icon]="'warning-regular'" [description]="'Oops, something went wrong' | translate">
          <button sb-button color="secondary" (click)="retryInitialLoad()">{{ 'Retry' | translate }}</button>
        </sb-empty-state>
      }
    </div>
  </div>
} @else {
  @if (noRequests()) {
    <div class="flex size-full flex-col">
      <div class="m-auto">
        <sb-empty-state [icon]="'clipboard-regular'" [description]="'No requests have been found' | translate" />
      </div>
    </div>
  }
  <!-- The sections stay mounted while empty (they render nothing then), so the open sections and
       the first-department default last for the whole panel session. -->
  <ng-container *subscriptionPlan="planType.BASIC">
    <department-sections [title]="'Pending requests' | translate" [sections]="pendingSections()" [expandFirst]="true">
      <ng-template let-group>
        @if (pendingSplits().get(group.items); as split) {
          <absence-request-notifications [absences]="split.absences" [alsoIn]="group.alsoIn" [showHeader]="false" />
          @if (split.supervisorApproval.length > 0) {
            @let supervisorApprovalId = idPrefix + '-' + group.departmentId + '-supervisor-approval';
            <section [attr.aria-labelledby]="supervisorApprovalId">
              <h5 [id]="supervisorApprovalId" class="reset-h px-sm pt-sm pb-xs text-sm font-bold text-subtle">
                {{ 'Pending supervisor approval' | translate }}
              </h5>
              <exchange-requests
                [exchanges]="split.supervisorApproval"
                [title]="'Pending supervisor approval' | translate"
                [context]="ExchangeRequestContext.PENDING_APPROVAL"
                [showAvatars]="true"
                [showHeader]="false"
              />
            </section>
          }
          @if (split.employeeAcceptance.length > 0) {
            @let employeeAcceptanceId = idPrefix + '-' + group.departmentId + '-employee-acceptance';
            <section [attr.aria-labelledby]="employeeAcceptanceId">
              <h5 [id]="employeeAcceptanceId" class="reset-h px-sm pt-sm pb-xs text-sm font-bold text-subtle">
                {{ 'Pending employee acceptance' | translate }}
              </h5>
              <exchange-requests
                [exchanges]="split.employeeAcceptance"
                [title]="'Pending employee acceptance' | translate"
                [showAvatars]="true"
                [showHeader]="false"
              />
            </section>
          }
        }
      </ng-template>
    </department-sections>
    <department-sections
      [title]="'Approved ongoing absences' | translate"
      [sections]="approvedOpenEndedAbsenceSections()"
    >
      <ng-template let-group>
        <absence-request-notifications [absences]="group.items" [alsoIn]="group.alsoIn" [showHeader]="false" />
      </ng-template>
    </department-sections>
  </ng-container>
}
